// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2BpTL","title":"AfterFrontImage_title__2fJkj"};